import { Routes } from '@angular/router';
import { secureRoutes } from './pages/secure/secure.routes';
import { publicRoutes } from './pages/public/public.routes';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: 'secure',
  },
  ...secureRoutes,
  ...publicRoutes
];
